import React from "react";

const Article = () => {
  return (
    <div>
      <div>
        <h2 id="Problem">Problem </h2>
        <p>
          Cadmium, a highly toxic heavy metal, poses a risk to large
          populations. It has been identified by the International Agency for
          Cancer as a group-one carcinogen and it is listed as one of 126
          priority pollutants by the Environmental Protection Agency.
          Notwithstanding, its mining and use continue to escalate worldwide as
          it is a critical component of many electronic devices. Mining and
          improper disposal of electronic devices result in cadmium
          contamination of soil and water, ultimately affecting our food
          supplies. This soil and water contamination particularly affects
          children and vegetarians{" "}
          <a href="#reference1">
            {" "}
            <sup>1</sup>{" "}
          </a>
          , due to bioaccumulation of the heavy metal in crops. As individuals
          are encouraged to reduce their meat consumption and embrace
          plant-based diets for the environmental benefits, they may
          inadvertently increase their exposure to cadmium. The growing trend in
          vegetarianism indicates that this problem will only become more severe
          with time. Taken together, our team feels this issue requires prompt
          action and a swift resolution.
        </p>
        <p>
          Despite the grave risks associated with cadmium ingestion, there is
          currently no treatment available. Therefore, it is crucial to urgently
          develop a solution to prevent the bioaccumulation of cadmium and
          mitigate its detrimental effects on human health.
        </p>
        <p>
          Cadmium contamination affects multiple communities, including those
          close to our EPFL team. A substantial percentage of the European
          Union’s population is exposed to dangerously high levels of cadmium,
          with nearly half of the population in France being affected. Moreover,
          the ramifications extend beyond Europe and have global implications.
          Various regions worldwide, including the United States, South and East
          Asia, and South America are grappling with the detrimental effects of
          cadmium contamination. It has been discovered that an alarming 3.0
          million people in the United States were provided with water that
          exceeded health guidelines for cadmium levels. It is clear to us that
          this issue is a matter of great importance on a global and local
          scale.
        </p>
        <h2 id="Current-solutions"> Current solutions </h2>
        <p>
          Despite the widespread nature of cadmium contamination and human
          exposure, a viable solution to eliminate it remains elusive. The
          current approach primarily concentrates on decontaminating soils and
          water sources. While this is an important step in mitigating further
          exposure, it fails to provide immediate relief to individuals who are
          already experiencing excessive cadmium exposure and toxicity. For this
          reason, our team is focusing on developing a therapeutic strategy to
          treat acute cadmium poisoning.
        </p>
        <h2 id="Our-solution"> Our solution </h2>
        <h3 id="Solution">
          A probiotic that effectively targets and reduces cadmium absorption in
          the human gut
        </h3>
        <p>
          To address the risks associated with cadmium exposure, it is crucial
          to raise public awareness and implement proactive preventive measures.
          Our proposed solution is to develop an implementation of a probiotic
          product, which aims to minimize the carcinogenic and toxic
          accumulation of cadmium in the human body.
        </p>
        <p>
          Our primary objective is to create modified bacteria that can
          temporarily attach to the mucus lining of the human small intestine
          and amass cadmium. While mucus bound, these engineered bacteria will
          bind with any cadmium that passes through the digestive system,
          effectively preventing its absorption into the body. Subsequently, the
          bacteria, carrying the cadmium, will be naturally eliminated from the
          body through the normal excretion processes (Figure 1). This approach
          aims to cleanse the bioaccumulation of cadmium.
        </p>
        <p>
          n the initial phase of our project, we propose to employ the bacterial
          strain Escherichia coli, commonly used in the laboratory, as a
          proof-of-concept strain, as it is well suited for laboratory
          manipulations and experiments. However, our ultimate objective is to
          progress towards using bacterial strains that naturally reside in the
          human gut, such as Lactobacillus. By employing these native gut
          bacteria, we can enhance compatibility and minimize potential
          disruptions to the natural microbial ecosystem within the intestines.
        </p>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Beatae,
          suscipit nesciunt iste omnis nam ullam officiis mollitia doloremque
          fuga, quisquam eligendi laborum, voluptate cupiditate minima alias
          perspiciatis corrupti. Magni, ipsam.
        </p>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Beatae,
          suscipit nesciunt iste omnis nam ullam officiis mollitia doloremque
          fuga, quisquam eligendi laborum, voluptate cupiditate minima alias
          perspiciatis corrupti. Magni, ipsam.
        </p>
        <h2 id="mucus">Mucus binding protein construct</h2>
        <p>
          Lorem ipsum dolor sit, amet consectetur adipisicing elit. Animi
          dolorum sit nobis in, officiis laboriosam debitis fuga fugiat ab
          tempore quasi soluta harum rerum, veniam dignissimos molestiae
          deleniti vero est?
        </p>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Beatae,
          suscipit nesciunt iste omnis nam ullam officiis mollitia doloremque
          fuga, quisquam eligendi laborum, voluptate cupiditate minima alias
          perspiciatis corrupti. Magni, ipsam.
        </p>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Beatae,
          suscipit nesciunt iste omnis nam ullam officiis mollitia doloremque
          fuga, quisquam eligendi laborum, voluptate cupiditate minima alias
          perspiciatis corrupti. Magni, ipsam.
        </p>
        <h2 id="References"> References </h2>
        <ul>
          <ol type="1">
            <li id="reference1">
              {" "}
              This is a reference{" "}
              <a href="https://r.mtdv.me/important-reference">
                <i>
                  <strong>The reference</strong>
                </i>
              </a>
            </li>
            <li id="reference2">
              {" "}
              This is{" "}
              <i>
                <strong>another</strong>
              </i>{" "}
              reference{" "}
            </li>
          </ol>
        </ul>
      </div>
    </div>
  );
};

export default Article;
